module.exports = __webpack_public_path__ + "img/quanxi.6eff9d0a.png";